<template>
  <div>
    <CHeader
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    >
      <CHeaderBrand class="mx-auto" to="/">
        <img
          src="../assets/img/pickiddologolargesizewhite.png"
          height="48px"
          class="m-2"
        />
      </CHeaderBrand>

      <CDropdown color="light" class="m-2 d-sm-flex d-md-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        <!-- <CDropdownItem
          style="width: 100% !important"
          href="https://pickiddo.com/about"
        >
          ABOUT US</CDropdownItem
        >
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem href="https://pickiddo.com/Tuition/UserGuide"
          >TUTORIAL</CDropdownItem
        > -->
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem to="/SearchTutor">REGISTER</CDropdownItem>
        <CDropdownItem to="/Partner">JOIN AS PARTNER</CDropdownItem>
        <CDropdownItem to="/SearchTutor">
          <CButton color="danger" size="sm" shape="pill"
            >REGISTER</CButton
          ></CDropdownItem
        >
      </CDropdown>

      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3"> </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/"> HOMEPAGE </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/about" exact>
            ABOUT US
          </CHeaderNavLink>
        </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Package">
            PRICING
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Partner">
            JOIN AS PARTNER
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3 ml-3">
          <CHeaderNavLink to="/SearchTutor">
            <CButton color="danger" size="sm" shape="pill"
              >REGISTER</CButton
            ></CHeaderNavLink
          >
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>
    <CJumbotron class="banner">
      <CRow>
        <CCol
          sm="12"
          lg="12"
          class="element-50 mt-5 text-center custom-center-pro"
        >
          <div>
            <h2
              style="font-weight: 700"
              class="custom-title-tutor text-white ml-5"
            >
              <b>Getting Started</b>
            </h2>
            <h4>
              Welcome to Pickiddo! We so glad you are here. Let's get started
            </h4>
          </div>
        </CCol>
      </CRow>
    </CJumbotron>
    <CCol sm="12" lg="12">
      <CContainer>
      
        <CRow>
          <CCol sm="12"><CHeaderNavLink to="/help"><span class="mb-3">Back to Help Page</span></CHeaderNavLink>
          <br /></CCol>
          <CCol sm="8" lg="8">
            <CCard>
              <div style="line-height: 2.5em" class="m-4">
                <h3>What is Pickiddo ?</h3>
                <p>
                  Cloud-based app, designed on anyone's smartphone to help
                  parents manage and monitor their children education through
                  their choosen tuition center.
                </p>

                <h3 class="mt-3">Where can I download Pickiddo ?</h3>
                <p>
                  User can download Pickiddo App in Google Play Store or App
                  Store.
                </p>
                <div class="text-center">
                  <CCard>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                    >
                      <img
                        style="max-width: 150px"
                        class="mt-2 mb-2"
                        src="../assets/img/gp2black.png"
                      />
                    </a>
                  </CCard>
                  <CCard>
                    <a
                      href="https://apps.apple.com/my/app/pickiddo/id1366167288"
                    >
                      <img
                        style="max-width: 150px"
                        class="ml-2 mt-2 mb-2"
                        src="../assets/img/gpblack.png"
                      />
                    </a>
                  </CCard>
                </div>

                <h3 class="mt-3">How I can register ?</h3>
                <b>For Parent register</b> <br />
                1. Install Pickiddo App and click <b>Sign Up</b><br />
                2. After confirm, enter <b>login</b> and <b>password.</b> <br />
                3. Click <b>Login </b><br />

                <b>For Teacher register</b> <br />
                1. Install Pickiddo App and click <b>Sign Up</b><br />
                2. After confirm, enter <b>login</b> and <b>password.</b> <br />
                3. Click <b>Login </b><br />

                <h3 class="mt-3">Why use Pickiddo ?</h3>
                <CIcon name="cil-input" class="text-success" height="20px" />
                Flexible Schedule <br />
                <CIcon name="cil-input" class="text-success" height="20px" />
                Various Subject <br />
                <CIcon name="cil-input" class="text-success" height="20px" />
                Best Tutor

                <h3 class="mt-3" id="Whocanusepickiddo">
                  Who can used Pickiddo App ?
                </h3>
                <CIcon name="cil-input" class="text-success" height="20px" />
                Teacher<br />
                <CIcon name="cil-input" class="text-success" height="20px" />
                Student <br />
                <CIcon name="cil-input" class="text-success" height="20px" />
                Parent
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard>
              <div style="line-height: 2.5em" class="m-4">
            <h4>Help</h4>

            <CIcon name="cil-notes" height="20px" class="mr-2"/>
            <a href="#Whatispickiddo">What is Pickiddo </a>
            <br />
            <CIcon name="cil-notes" height="20px" class="mr-2"/>
            <a href="#Whatispickiddo">Where can I download Pickiddo ? </a>
            <br />
            <CIcon name="cil-notes" height="20px" class="mr-2"/>
            <a href="#Whatispickiddo">How I can register ? </a>
            <br />
            <CIcon name="cil-notes" height="20px" class="mr-2"/>
            <a href="#Whatispickiddo">Why use Pickiddo ? </a>
            <br />
            <CIcon name="cil-notes" height="20px" class="mr-2" />
            <a href="#Whocanusepickiddo">Who can used Pickiddo App ?</a>
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </CCol>
  </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import backgroundCounter from "../assets/img/bgmap.png";
import backgroundUrlApps from "../assets/img/bg3Copy-1.png";
import backgroundCount from "../assets/img/Landingpage.png";

import video from "../assets/img/register.mp4";
import video2 from "../assets/img/register1.mp4";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import _ from "lodash";

export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      successModal: false,
      CustomerName: "",
      CustomerEmail: "",
      CustomerPhoneNumber: "",

      backgroundCounter,
      backgroundCount,
      backgroundUrlApps,
      view: {
        topOfPage: true,
      },

      video,
      video2,

      slides: 7,
      autoplay: true,
      loop: true,
      playerOptions: {
        loop: true,
        autoplay: true,
      },
      playerOption: {},
      autoplay: {
        // automatically play the video
        type: Boolean,
        default: () => true,
      },
      loop: {
        // loop the video infinitely
        type: Boolean,
        default: () => true,
      },
      cardList: false,
      toggle: false,
    };
  },
  created() {
    AOS.init();
  },
  async mounted() {},
  methods: {
    GoToPageFaq() {
      this.$router.push("/Faq");
    },
    GotoWhatsap() {
      location.replace(
        "https://wa.me/600106597700?text=+Hi, I would like to ask about pickiddo "
      );
    },

    toggles: function (item) {
      item.isActive = !item.isActive;
    },

    navbarShow() {
      this.cardList = true;
    },
    GoToPagePro() {
      this.$router.push("/ProClass");
    },
    GotoLogin() {
      this.$router.push("https://pickiddo.com/TuitionCenter/Login");
    },
    GotoApple() {
      this.$router.push("https://apps.apple.com/my/app/pickiddo/id1366167288");
    },
    GotoGoogle() {
      this.$router.push(
        "https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
      );
    },

    ShowButtonSubmit() {
      this.ShowButton = true;
    },
  },
};
</script>


<style>
body {
  background: #fff;
  font-family: "Rubik", sans-serif;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.3rem;
}
.item-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 120%;
  margin-bottom: 10px;
  font-weight: 500;
  color: #4a4a4a;
}

.item-desc {
  font-size: 14px;
  line-height: 140%;
  min-height: 60px;
}

.card .custom-hover:hover {
  transition: 0.15s all ease-in-out;
  transform: scale(1.1);
  z-index: 100;
  background-color: #fff;
}
.banner {
  position: relative;
  background-image: url(../assets/img/transparent.png),
    linear-gradient(-150deg, #174d7c 0%, #51baa9 97%);
  background-size: 380px, contain;
  background-position: center;
  color: #fff;
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>
